export const aciBeachPoolFacilities = {
    iconName: 'beach-pool-facilities',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                d: 'M20.681 12.778a1.8 1.8 0 00-2.503-.46L14.4 15H6.6a1.8 1.8 0 100 3.6H15c.452 0 .887-.172 1.217-.48l4.006-2.84a1.8 1.8 0 00.458-2.502zM7.199 18.6l-.6 2.4M15.598 18.6l1.2 2.4M6 7.157a1.8 1.8 0 103.6 0 1.8 1.8 0 00-3.6 0zM11.4 7.157h1.2M4.2 7.157H3M9.6 4.04L10.2 3M6 10.274l-.6 1.04M6 4.04L5.4 3M9.6 10.274l.6 1.04',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
